import styles from './skeleton.module.css';

interface ISkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  className?: string;
}

export const Skeleton = (props: ISkeletonProps) => {
  const {
    width,
    height,
    borderRadius = 7,
    className = ''
  } = props;

  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    minWidth: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
  };

  return (
    <div
      className={`${styles.skeleton} ${className}`}
      style={style}
    />
  );
};
